/**
 * Application constants
 */

export const APP_CONFIG = {
  name: 'Bookiner',
  description: 'Plateforme d\'achat et de revente de livres',
  contact: {
    email: 'contact@bookiner.com',
  },
};

export const ROUTES = {
  home: '/',
};

export const API_ENDPOINTS = {
  newsletter: '/api/newsletter/subscribe',
  earlyAccess: '/api/early-access/register',
};

export const FORM_MESSAGES = {
  success: {
    newsletter: 'Merci ! Vous êtes inscrit à notre newsletter.',
    earlyAccess: 'Merci ! Vous êtes sur la liste d\'accès anticipé.',
  },
  error: {
    generic: 'Une erreur est survenue. Veuillez réessayer.',
    invalidEmail: 'Veuillez entrer une adresse email valide.',
    required: 'Ce champ est requis.',
  },
};
